module.exports = __webpack_public_path__ + "img/c3.08b98a37.png";